/** @format */

import React, {useCallback, useState} from 'react';
import SuperAgent from 'superagent';

export default function useDesignArchive(designId, onArchive, onUnarchive) {
    const [isShowingForm, setIsShowingForm] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const handleArchive = () => {
        setIsSaving(true);
        setIsSaved(false);
        SuperAgent.post('/account/designs/archive/' + designId)
            .set('accept', 'application/json')
            .send()
            .end(() => {
                setIsSaving(false);
                setIsSaved(true);
                onArchive();
            });
    };

    const handleUnarchive = () => {
        setIsSaving(true);
        setIsSaved(false);
        SuperAgent.post('/account/designs/un-archive/' + designId)
            .set('accept', 'application/json')
            .send()
            .end(() => {
                setIsSaving(false);
                setIsSaved(true);
                onUnarchive();
            });
    };

    return {
        toggleIsShowingArchive: useCallback(() => {
            setIsShowingForm(!isShowingForm);
        }, [isShowingForm]),
        handleUnarchive,
        handleArchive,
        isShowingArchiveForm: isShowingForm,
        isArchivingDesign: isSaving,
        isArchivingDesignDone: isSaved
    };
}
